import React from 'react'
import Slider from 'react-slick'
import { Font, Wrapper } from 'components'
import cx from 'classnames'
import { ReactComponent as Title } from 'assets/images/title.svg'
import { ReactComponent as TitleXS } from 'assets/images/title-xs.svg'
import styles from './styles.module.scss'

const settings = {
  dots: false,
  infinite: true,
  speed: 300,
  itemsToShow: 1,
  centerMode: true,
  variableWidth: true,
  autoplay: true,
  autoplaySpeed: 2000,
}

const testimonials = [
  'omg yum',
  'Great value',
  'Pretty plates',
  'Local gem',
  '🤤 🤤 🤤',
  'Date night',
  'obsessed',
  'cozy',
  `❤️️ ❤️️ my go-to`,
]

const RecommendSection = () => {
  return (
    <div className={styles.container}>
      <Wrapper className={styles.wrapper}>
        <Font type="bodyLato" weight="semiBold" className={styles.caption}>
          Research, recommend and reconnect with friends through a common love
          of food by sharing photos, recipes and experiences with your social
          network.
        </Font>
      </Wrapper>

      <div className={styles.sliderContainer}>
        <Slider {...settings}>
          {testimonials.map(t => {
            return (
              <div key={t} className={styles.itemContainer}>
                <Font type="bodyLato" weight="bold" className={styles.item}>
                  {t}
                </Font>
              </div>
            )
          })}
        </Slider>
      </div>

      <Wrapper className={styles.wrapper}>
        <div className={styles.titleXS}>
          <TitleXS />
        </div>
        <div className={styles.title}>
          <Title />
        </div>
        <Font className="mt-52" weight="bold">
          Discovered a neighborhood gem? Found a killer recipe?
        </Font>
        <Font>
          Share your intel with ratings, tags and write-in comments for more
          detail.
        </Font>
      </Wrapper>
    </div>
  )
}

export default RecommendSection
